import {
  filter,
  tap,
  ignoreElements,
  switchMap,
  mergeMap,
  catchError,
} from 'rxjs/operators'
import {of, concat, from} from 'rxjs'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {SettingsService} from 'services/api'
import {settingsActions} from '../settingsSlice'
import Toast from 'components/Basic/Toast'

const getEndpointsConfigEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.getEndpointsConfig.match),
    switchMap(() =>
      from(SettingsService.getEndpointsConfig()).pipe(
        mergeMap(({data}) => [settingsActions.getEndpointsConfigSuccess(data)]),
        catchError((message: string) =>
          concat(of(settingsActions.getEndpointsConfigFailure(message))),
        ),
      ),
    ),
  )

const getEndpointsConfigFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.getEndpointsConfigFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const updateEndpointsConfigEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.updateEndpointsConfig.match),
    switchMap(({payload}) =>
      from(SettingsService.updateEndpointsConfig(payload)).pipe(
        mergeMap(() => [
          settingsActions.updateEndpointsConfigSuccess(
            'Config Updated Successfully',
          ),
        ]),
        catchError((message: string) =>
          concat(of(settingsActions.updateEndpointsConfigFailure(message))),
        ),
      ),
    ),
  )

const updateEndpointsConfigFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.updateEndpointsConfigFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const updateEndpointsConfigSuccessEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(settingsActions.updateEndpointsConfigSuccess.match),
    tap(({payload: message}) => Toast({message, type: 'success'})),
    ignoreElements(),
  )

export const endpointsEpics = [
  getEndpointsConfigEpic,
  getEndpointsConfigFailureEpic,
  updateEndpointsConfigEpic,
  updateEndpointsConfigFailureEpic,
  updateEndpointsConfigSuccessEpic,
]
